export default function CollapsibleTile({ emoji, title, summary, expanded, onToggle, children, style = {} }) {
  return (
    <div style={{ marginBottom: '8px', ...style }}>
      <div
        onClick={onToggle}
        style={{
          background: '#FDFAF6',
          borderRadius: expanded ? '12px 12px 0 0' : '12px',
          padding: '16px 20px',
          cursor: 'pointer',
          border: '1px solid #DDD4C6',
          borderBottom: expanded ? 'none' : '1px solid #DDD4C6',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <span style={{ fontSize: '20px' }}>{emoji}</span>
          <div>
            <div style={{ fontFamily: 'Georgia, serif', fontSize: '15px', color: '#2C1D14' }}>{title}</div>
            {summary && (
              <div style={{ fontSize: '12px', color: '#9A7B68', marginTop: '2px', fontFamily: 'Calibri, sans-serif' }}>{summary}</div>
            )}
          </div>
        </div>
        <div style={{
          color: '#9A7B68', fontSize: '18px',
          transition: 'transform 0.2s',
          transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
          lineHeight: 1,
        }}>
          ▾
        </div>
      </div>
      {expanded && (
        <div style={{
          background: '#FDFAF6',
          borderRadius: '0 0 12px 12px',
          padding: '20px',
          border: '1px solid #DDD4C6',
          borderTop: 'none',
        }}>
          {children}
        </div>
      )}
    </div>
  )
}
